var map = {
	"./001-slideshow.jpg": "UrCo",
	"./002-slideshow.jpg": "DqlF",
	"./003-slideshow.jpg": "wZJj",
	"./004-slideshow.jpg": "PW6o",
	"./005-slideshow.jpg": "z7Z6",
	"./006-slideshow.jpg": "u1X5",
	"./007-slideshow.jpg": "b6Qz",
	"./008-slideshow.jpg": "rGnL",
	"./009-slideshow.jpg": "MMOw",
	"./010-slideshow.jpg": "h6Xz",
	"./011-slideshow.jpg": "IyiG",
	"./012-slideshow.jpg": "cKQp",
	"./013-slideshow.jpg": "8vQY",
	"./014-slideshow.jpg": "B95H",
	"./015-slideshow.jpg": "c6KS",
	"./016-slideshow.jpg": "xVns",
	"./017-slideshow.jpg": "boSX",
	"./018-slideshow.jpg": "zg0k",
	"./019-slideshow.jpg": "MutL",
	"./20-slideshow.jpg": "sYGk",
	"./21-slideshow.jpg": "pToP",
	"./22-slideshow.jpg": "ht47",
	"./23-slideshow.jpg": "jSC9",
	"./24-slideshow.jpg": "8aYy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C7xP";